var map = {
	"./auth/locale/fa.json": "33f7",
	"./azmoon/locale/fa.json": "dc94",
	"./cooperation/locale/fa.json": "c1d9",
	"./home/locale/fa.json": "4463",
	"./interview/locale/fa.json": "bd5c",
	"./jobsProfile/locale/fa.json": "ac7f",
	"./kanoon/locale/fa.json": "5aa0",
	"./profile/locale/fa.json": "5775",
	"./report/locale/fa.json": "ff81",
	"./research/locale/fa.json": "7b95",
	"./survey/locale/fa.json": "2bd3",
	"./task/locale/fa.json": "78fe",
	"./ticket/locale/fa.json": "8941"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d09d";